<template>
  <NewToolShell v-if="variant === 'new'" :title="title" :subtitle="subtitle">
    <div class="ar-shell-body">
      <slot />
    </div>
  </NewToolShell>
  <div v-else class="results-container results-container--legacy">
    <slot />
  </div>
</template>

<script>
import NewToolShell from "@/views/NewToolShell.vue";

export default {
  name: "AssessmentResultsLayout",
  components: { NewToolShell },
  props: {
    variant: { type: String, required: true },
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
  },
};
</script>

<style scoped>
.ar-shell-body {
  text-align: center;
}

.results-container--legacy {
  max-width: 1300px;
  margin: auto;
  text-align: center;
  padding: 30px;
  background: #f4f6f9;
  font-family: Arial, sans-serif;
}
</style>
